<template>
  <section class="order-activity-rewards" data-order-activity-rewards>
    <div class="reward-title">活动赠送记录</div>
    <p v-if="failed" class="reward-failed">活动赠送记录读取失败，请重新打开订单详情。</p>
    <template v-else-if="rows.length">
      <p v-if="rows.some(row => row.pending)" class="reward-notice">待发放赠品将在订单支付成功后发放。</p>
      <article v-for="row in rows" :key="row.id" class="reward-record" data-reward-record>
        <div><strong>{{row.activityName}}</strong><span class="reward-status">{{row.status}}</span></div>
        <div>活动规则：{{row.ruleText}}；活动支付模式：{{row.mode}}</div>
        <div data-reward-detail>{{row.rewardText}}</div>
        <div v-if="row.failReason" class="reward-failed">原因：{{row.failReason}}</div>
      </article>
    </template>
    <p v-else>无活动赠送记录</p>
  </section>
</template>
<script>
import { orderActivityRewards } from '@/utils/orderActivityRewards'
export default {
  props: { records: { type: Array, default: () => [] }, failed: { type: Boolean, default: false } },
  computed: { rows() { return orderActivityRewards(this.records) } }
}
</script>
<style scoped>
.order-activity-rewards { margin: 20px 0; line-height: 1.8; }
.reward-title { font-size: 16px; border-left: 4px solid #5dbde7; padding-left: 6px; color: #303133; }
.reward-notice { color: #606266; }
.reward-record { padding: 10px 12px; margin-top: 8px; background: #f5f9fc; border: 1px solid #e5edf3; }
.reward-status { margin-left: 16px; color: #409eff; }
.reward-failed { color: #c45656; }
</style>
